import { useMutation } from '@tanstack/react-query';
import { axiosGlobalInstance } from 'api/axios/global';
import { routes } from 'api/routes';

type DeleteClientUser = {
  clientUserId: number;
  clientId: number;
};

const remove = async (values: DeleteClientUser) => {
  const { clientId, clientUserId } = values;
  return axiosGlobalInstance.delete(
    `${routes['clients']}/${clientId}/clientUsers/${clientUserId}`,
  );
};

const useDeleteClientUser = () => {
  return useMutation({
    mutationFn: (values: DeleteClientUser) => remove(values),
  });
};

export default useDeleteClientUser;
